module.exports = __webpack_public_path__ + "img/light-open.c64a12c4.png";